import {
  FacilitiesApiClient,
  createFacilitiesApiClient,
} from '@peritasai/data-access';
import type {
  FacilityDto,
  FacilitiesFilterParams,
  CreateFacilityDto,
  PaginatedFacilitiesResponseDto,
  UpdateFacilityDto,
} from '@peritasai/types';
import { FacilityEntity } from './facility.entity';

export interface IFacilitiesRepository {
  getFacilitiesPaginated(
    options: FacilitiesFilterParams
  ): Promise<PaginatedFacilitiesResponseDto & { facilities: FacilityEntity[] }>;
  createFacility(dto: CreateFacilityDto): Promise<FacilityEntity>;
  updateFacility(id: string, dto: UpdateFacilityDto): Promise<FacilityEntity>;
}

export class FacilitiesRepository implements IFacilitiesRepository {
  constructor(private readonly apiClient: FacilitiesApiClient) {}

  async getFacilitiesPaginated(
    options: FacilitiesFilterParams = {}
  ): Promise<PaginatedFacilitiesResponseDto & { facilities: FacilityEntity[] }> {
    const response = await this.apiClient.getFacilities(options);
    return {
      ...response,
      facilities: response.data.map((dto) => this.toEntity(dto)),
    };
  }

  async createFacility(dto: CreateFacilityDto): Promise<FacilityEntity> {
    const result = await this.apiClient.createFacility(dto);
    return this.toEntity(result);
  }

  async updateFacility(id: string, dto: UpdateFacilityDto): Promise<FacilityEntity> {
    const result = await this.apiClient.updateFacility(id, dto);
    return this.toEntity(result);
  }

  private toEntity(dto: FacilityDto): FacilityEntity {
    return new FacilityEntity(dto);
  }
}

export const facilitiesRepository = new FacilitiesRepository(createFacilitiesApiClient());
